/** Network pages: buses, arrangement, zones, lines and stations. */
export default {
  // Buses
  'Could not assign': 'Caktimi dështoi',
  'Out of service': 'Jashtë funksionit',
  'out of service': 'jashtë funksionit',
  'On route': 'Në qarkullim',
  'At terminus': 'Në stacionin fundor',
  Status: 'Statusi',
  'Avg speed': 'Shpejtësia mesatare',
  Location: 'Vendndodhja',
  'Arvento ID {id}': 'ID-ja në Arvento {id}',
  Speed: 'Shpejtësia',
  'Avg (15 min)': 'Mesatarja (15 min)',
  Heading: 'Drejtimi',
  Address: 'Adresa',
  'The bus is created again automatically if Arvento keeps reporting it.':
    'Busi krijohet sërish automatikisht nëse Arvento vazhdon ta raportojë.',

  // Arrangement
  'Could not move the bus': 'Zhvendosja e busit dështoi',
  'Find a bus…': 'Gjej një bus…',
  'Move {name}': 'Zhvendos {name}',
  'Move to…': 'Zhvendos te…',
  'Drop buses here': 'Lëshoni busat këtu',

  // Zones
  Route: 'Rruga',
  Going: 'Vajtje',
  Return: 'Kthim',
  Order: 'Renditja',
  'In service': 'Në funksion',
  'Not in service': 'Jo në funksion',
  'Bus sign': 'Shenja e busit',
  'Shown on buses, e.g. 1 or 3A': 'Shfaqet në busa, p.sh. 1 ose 3A',
  'Order in app': 'Renditja në aplikacion',
  Colour: 'Ngjyra',
  '— none —': '— asnjë —',
  'In service (buses visible in the app)': 'Në funksion (busat shfaqen në aplikacion)',
  'Going fence': 'Perimetri i vajtjes',
  'Return fence': 'Perimetri i kthimit',

  // Lines
  Sign: 'Shenja',
  'From → to': 'Nga → deri',
  'Draw the route, then list the stations in the order the bus serves them.':
    'Vizatoni rrugën, pastaj renditni stacionet sipas radhës në të cilën i kalon busi.',
  '{n} point': '{n} pikë',
  '{n} points': '{n} pika',
  'Draw the route on the map': 'Vizatoni rrugën në hartë',
  'Stations in order ({n})': 'Stacionet sipas radhës ({n})',
  'Move up': 'Lëviz lart',
  'Move down': 'Lëviz poshtë',

  // Stations
  'New station': 'Stacion i ri',
  'All lines': 'Të gjitha linjat',
  Coordinates: 'Koordinatat',
  'Timetables at this station': 'Oraret në këtë stacion',
  'No timetables yet': 'Ende nuk ka orare',
  Position: 'Pozita',
  'Click on the map': 'Klikoni në hartë',
  '{n} station': '{n} stacion',
  '{n} stations': '{n} stacione',
  '{n} min': '{n} min',
  '{n} h': '{n} orë',
  Until: 'Deri',
  'Until (empty: now, updated live)': 'Deri (bosh: tani, përditësohet drejtpërdrejt)',
  'Recent logs': 'Regjistrat e fundit',
  'Replay copy': 'Kopja për riprodhim',
  'Agreement {n}%': 'Përputhje {n}%',
  'Turns: legacy {a} · v2 {b}': 'Kthesa: i vjetri {a} · v2 {b}',
  'No positions in this period.': 'Nuk ka pozita në këtë periudhë.',
  'Only the first 20,000 positions are shown.': 'Shfaqen vetëm 20.000 pozitat e para.',
  'Off route': 'Jashtë linjës',
  going: 'vajtje',
  return: 'kthim',
  'Edit station': 'Ndrysho stacionin',
  'Arriving within 30 minutes': 'Arrijnë brenda 30 minutave',
  'No bus on the way right now.': 'Asnjë bus nuk është rrugës tani.',
  'Edit bus': 'Ndrysho busin',
  'Standing still': 'I ndalur',
  Towards: 'Drejt',
  'Direction (new logic)': 'Drejtimi (logjika e re)',
  'Next stations': 'Stacionet e ardhshme',
  'No stations ahead.': 'Nuk ka stacione përpara.',
  '{n} stations already passed': '{n} stacione të kaluara',
  'Bus with the selected ID not found / not active.': 'Busi nuk u gjet ose nuk është aktiv.',
  'Bus is not currently assigned to any line.': 'Busi aktualisht nuk është në asnjë linjë.',
  'Map and recent route': 'Harta dhe rruga e fundit',
  'The coloured line is where the bus drove in this period, in the direction the system detected:':
    'Vija me ngjyrë tregon ku ka lëvizur busi në këtë periudhë, sipas drejtimit që ka njohur sistemi:',
  'blue = going (A → B)': 'blu = vajtje (A → B)',
  'orange = return (B → A)': 'portokalli = kthim (B → A)',
  'grey = off route': 'gri = jashtë linjës',
  'Last position {time}.': 'Pozita e fundit {time}.',
  'Compare with the old logic (terminus fences only)':
    'Krahaso me logjikën e vjetër (vetëm perimetrat e stacioneve fundore)',
  'the old logic chose the other direction': 'logjika e vjetër zgjodhi drejtimin tjetër',
  '{fence}: not drawn yet.': '{fence}: ende nuk është vizatuar.',
  '{fence} is at {p} ({name}).': '{fence} është te {p} ({name}).',
  '{fence} is at the other end, not at {p}: the fences look swapped.':
    '{fence} është në skajin tjetër, jo te {p}: perimetrat duken të ndërruar.',
  '{fence} is {m} m from {p} ({name}).': '{fence} është {m} m larg {p} ({name}).',
  'How the direction is decided': 'Si vendoset drejtimi',
  'Swap the two fences': 'Ndërro dy perimetrat',
  'Show on the map': 'Shfaqe në hartë',
  'Out of order: the route reaches it earlier': 'Jashtë radhës: rruga e arrin më herët',
  '{m} m from the route': '{m} m larg rrugës',
  '{n} stop needs a look: it is away from the route or out of order.':
    '{n} stacion duhet kontrolluar: është larg rrugës ose jashtë radhës.',
  '{n} stops need a look: they are away from the route or out of order.':
    '{n} stacione duhen kontrolluar: janë larg rrugës ose jashtë radhës.',
  'Timetables saved for {n} stations': 'Oraret u ruajtën për {n} stacione',
  'Timetable: {line}': 'Orari: {line}',
  'Return direction: {line}': 'Drejtimi i kthimit: {line}',
  '1 · Departures from {station}': '1 · Nisjet nga {station}',
  'Same as weekdays': 'Njësoj si ditët e javës',
  'Add or remove single departures here, e.g. an extra early bus.':
    'Shtoni ose hiqni nisje të veçanta këtu, p.sh. një autobus shtesë herët në mëngjes.',
  '2 · Travel time from {station}': '2 · Koha e udhëtimit nga {station}',
  'Read the travel times from the timetables saved now': 'Merr kohët e udhëtimit nga oraret e ruajtura tani',
  'From current timetables': 'Nga oraret aktuale',
  'Distance along the route at this speed, plus half a minute per stop':
    'Distanca përgjatë rrugës me këtë shpejtësi, plus gjysmë minute për çdo ndalesë',
  'Estimate from route': 'Vlerëso nga rruga',
  'Average speed (km/h)': 'Shpejtësia mesatare (km/h)',
  Minutes: 'Minuta',
  'From previous': 'Nga i mëparshmi',
  'Minutes to {station}': 'Minuta deri te {station}',
  start: 'nisja',
  '3 · Times at every station ({day})': '3 · Oraret në çdo stacion ({day})',
  'new': 'e re',
  'Set the travel time to every station first ({n} missing).':
    'Caktoni fillimisht kohën e udhëtimit deri te çdo stacion (mungojnë {n}).',
  'Travel times go backwards at {station}.': 'Kohët e udhëtimit zvogëlohen te {station}.',
  'Save timetables of {n} stations': 'Ruaj oraret e {n} stacioneve',
  Rules: 'Rregullat',
  'E.g. 06:00–09:00 every 10 min and 09:00–22:00 every 20 min, then "Fill departures from the rules".':
    'P.sh. 06:00–09:00 çdo 10 min dhe 09:00–22:00 çdo 20 min, pastaj "Plotëso nisjet nga rregullat".',
  From: 'Nga',
  to: 'deri',
  every: 'çdo',
  min: 'min',
  'Add rule': 'Shto rregull',
  'Fill departures from the rules': 'Plotëso nisjet nga rregullat',
  'No departures yet for these days.': 'Ende nuk ka nisje për këto ditë.',
  Changes: 'Ndryshime',
  removed: 'hequr',
  '{n} station changes': '{n} stacion ndryshon',
  '{n} stations change': '{n} stacione ndryshojnë',
  '{n} stays the same': '{n} mbetet njësoj',
  '{n} stay the same': '{n} mbeten njësoj',
  'By station': 'Sipas stacionit',
  'Stations with times': 'Stacione me orar',
  'Last edited': 'Ndryshuar së fundi',
  'Timetable of {line}': 'Orari i {line}',
  'Line updated': 'Linja u përditësua',
  'No line': 'Pa linjë',
  'Vehicles reported by Arvento. Assign a bus to a line to show it in the app.':
    'Automjetet e raportuara nga Arvento. Caktojeni një autobus në një linjë për ta shfaqur në aplikacion.',
  'Drag a bus to a line to put it on that line; drag it to “Out of service” to take it off the app.':
    'Tërhiqni një autobus te një linjë për ta vënë në atë linjë; tërhiqeni te “Jashtë funksionit” për ta hequr nga aplikacioni.',
  'Line not in service': 'Linja nuk është në funksion',
  'A line with its two directions. Buses assigned to a line switch direction at the terminus fences.':
    'Një linjë me dy drejtimet e saj. Autobusët e caktuar në një linjë ndërrojnë drejtim te perimetrat e stacioneve fundore.',
  'New line': 'Linjë e re',
  'Also applied to both directions.': 'Zbatohet edhe në të dy drejtimet.',
  'Going direction': 'Drejtimi i vajtjes',
  'Return direction': 'Drejtimi i kthimit',
  'Lines with assigned buses cannot be deleted.': 'Linjat me autobusë të caktuar nuk mund të fshihen.',
  'One direction of a line: its path and its stations in travel order. Colour and sign come from the line.':
    'Një drejtim i linjës: rruga dhe stacionet sipas radhës së udhëtimit. Ngjyra dhe shenja vijnë nga linja.',
  'New direction': 'Drejtim i ri',
  'Directions used by a line or by buses cannot be deleted. Timetables of this direction are removed.':
    'Drejtimet që përdoren nga një linjë ose nga autobusë nuk mund të fshihen. Oraret e këtij drejtimi fshihen.',
  'Bus stops shown in the app. A station belongs to one or more directions.':
    'Stacionet e autobusëve që shfaqen në aplikacion. Një stacion i përket një ose më shumë drejtimeve.',
  "Adding a direction places this station by its position on the route; reorder stations on the direction's page.":
    'Shtimi i një drejtimi e vendos stacionin sipas pozitës në rrugë; radhitjen e ndryshoni te faqja e drejtimit.',
  'Show the direction': 'Shfaq drejtimin',
  'Show directions': 'Shfaq drejtimet',
  'The faint lines with arrows are the two directions of the line.':
    'Vijat e zbehta me shigjeta janë dy drejtimet e linjës.',
  'The fences of this line do not sit at A and B.': 'Perimetrat e kësaj linje nuk janë te A dhe B.',
  'Check the line': 'Kontrollo linjën',
  '{fence}: drawn (choose the directions to check its position).':
    '{fence}: i vizatuar (zgjidhni drejtimet për të kontrolluar pozitën).',
  'A bus that enters the going fence starts the going direction (A → B); one that enters the return fence starts the return direction (B → A). So the going fence belongs at A, the return fence at B.':
    'Autobusi që hyn në perimetrin e vajtjes fillon drejtimin e vajtjes (A → B); ai që hyn në perimetrin e kthimit fillon drejtimin e kthimit (B → A). Prandaj perimetri i vajtjes duhet te A, ai i kthimit te B.',
  'The new direction logic also follows how the bus moves along both directions, so a missed fence no longer keeps a bus in the wrong direction.':
    'Logjika e re e drejtimit ndjek edhe lëvizjen e autobusit përgjatë të dy drejtimeve, kështu që një perimetër i humbur nuk e mban më autobusin në drejtimin e gabuar.',
  'The return direction starts at B and ends at A.': 'Drejtimi i kthimit fillon te B dhe mbaron te A.',
  'The return direction does not start at B and end at A: check the chosen directions.':
    'Drejtimi i kthimit nuk fillon te B dhe nuk mbaron te A: kontrolloni drejtimet e zgjedhura.',
  'Set when buses leave {first} and how long they take to each station. The times at every station of this direction follow from that and are saved together.':
    'Caktoni kur nisen autobusët nga {first} dhe sa kohë u duhet deri te secili stacion. Oraret e të gjitha stacioneve të këtij drejtimi llogariten nga kjo dhe ruhen së bashku.',
  'By direction': 'Sipas drejtimit',
  'This changes one station only. To set the times of every station of the direction at once:':
    'Kjo ndryshon vetëm një stacion. Për të caktuar oraret e të gjitha stacioneve të drejtimit njëherësh:',
  'Drag a stop to change the order. Point at a station on the map to add or remove it; new stops are placed by their position on the route.':
    'Tërhiqni një stacion për të ndryshuar radhën. Vendosni kursorin mbi një stacion në hartë për ta shtuar ose hequr; stacionet e reja vendosen sipas pozitës në rrugë.',
  none: 'asnjë',
  'Edit timetable': 'Ndrysho orarin',
  'stop {n} of {m}': 'stacioni {n} nga {m}',
  'Directions without a line': 'Drejtime pa linjë',
  'Served by': 'Shërbehet nga',
  Details: 'Të dhënat',
  'Directions that stop here ({n})': 'Drejtimet që ndalen këtu ({n})',
  'Open in Google Maps': 'Hape në Google Maps',
  'Drag the sign on the map, or click where the stop is.':
    'Tërhiqni shenjën në hartë ose klikoni aty ku është stacioni.',
  '{m} m from the route of {direction}': '{m} m larg rrugës së {direction}',
  'Click on the map where the stop is.': 'Klikoni në hartë aty ku është stacioni.',
  'Edit direction': 'Ndrysho drejtimin',
  Monitoring: 'Mbikëqyrja',
  Performance: 'Performanca',
  'Usual travel times measured from the buses ({n} trips in the last 30 days)':
    'Kohët e zakonshme të udhëtimit të matura nga autobusët ({n} udhëtime në 30 ditët e fundit)',
  'No trips recorded yet for this direction': 'Ende nuk ka udhëtime të regjistruara për këtë drejtim',
  'From bus history': 'Nga historiku i autobusëve',
  'How each direction runs in practice, from when buses actually passed its stations.':
    'Si funksionon çdo drejtim në praktikë, sipas kohës kur autobusët kaluan realisht nëpër stacionet e tij.',
  'Choose a direction…': 'Zgjidhni një drejtim…',
  'Choose a direction to see how it runs.': 'Zgjidhni një drejtim për të parë si funksionon.',
  'No trips recorded for this direction in this period yet. They are read from the bus positions every 2 minutes, so they build up from now on.':
    'Ende nuk ka udhëtime të regjistruara për këtë drejtim në këtë periudhë. Ato lexohen nga pozitat e autobusëve çdo 2 minuta, kështu që grumbullohen nga tani e tutje.',
  'Trips per day': 'Udhëtime në ditë',
  'Travel time, first to last stop': 'Koha e udhëtimit, nga stacioni i parë te i fundit',
  'slow trips: {n} min': 'udhëtimet e ngadalta: {n} min',
  'Usual gap between buses': 'Intervali i zakonshëm mes autobusëve',
  'On time (timetable)': 'Në kohë (sipas orarit)',
  '{late} late · {early} early of {n} stops': '{late} me vonesë · {early} herët nga {n} ndalesa',
  'No timetable for these days': 'Nuk ka orar për këto ditë',
  'Travel time by hour of departure': 'Koha e udhëtimit sipas orës së nisjes',
  usual: 'zakonisht',
  'slow trips': 'udhëtimet e ngadalta',
  '{h}:00 · usual {a} min · slow {b} min · {n} trips':
    '{h}:00 · zakonisht {a} min · ngadalë {b} min · {n} udhëtime',
  'Gap between buses by hour': 'Intervali mes autobusëve sipas orës',
  'longest gaps': 'intervalet më të gjata',
  '{h}:00 · usual {a} min · longest {b} min · bunched {c}':
    '{h}:00 · zakonisht {a} min · më i gjati {b} min · bashkë {c}',
  'Time between stops': 'Koha mes stacioneve',
  'Punctuality by stop': 'Përpikëria sipas stacionit',
  'This direction has no timetable for these days, so there is nothing to compare with.':
    'Ky drejtim nuk ka orar për këto ditë, prandaj nuk ka me çfarë të krahasohet.',
  'Set the timetable': 'Cakto orarin',
  minutes: 'minuta',
  slow: 'ngadalë',
  'on time': 'në kohë',
  '{n} min late': '{n} min vonesë',
  '{n} min early': '{n} min herët',
  'Each passing compared with the nearest timetable time. On time: up to {e} min early or {l} min late.':
    'Çdo kalim krahasohet me kohën më të afërt në orar. Në kohë: deri në {e} min herët ose {l} min vonë.',
  Stop: 'Stacioni',
  Usually: 'Zakonisht',
  'On time': 'Në kohë',
  '{n} day with data': '{n} ditë me të dhëna',
  '{n} days with data': '{n} ditë me të dhëna',
  '{n} time two buses left together': '{n} herë dy autobusë u nisën bashkë',
  '{n} times two buses left together': '{n} herë dy autobusë u nisën bashkë',
  'Data health': 'Shëndeti i të dhënave',
  'Has no going direction.': 'Nuk ka drejtim të vajtjes.',
  'Has no return direction.': 'Nuk ka drejtim të kthimit.',
  'The fences look swapped.': 'Perimetrat duken të ndërruar.',
  'The going fence is {m} m from the start of the going direction.':
    'Perimetri i vajtjes është {m} m larg fillimit të drejtimit të vajtjes.',
  'The return fence is {m} m from the start of the return direction.':
    'Perimetri i kthimit është {m} m larg fillimit të drejtimit të kthimit.',
  'The return direction does not start where the going direction ends.':
    'Drejtimi i kthimit nuk fillon aty ku mbaron drejtimi i vajtjes.',
  'Not used by any line.': 'Nuk përdoret nga asnjë linjë.',
  'Has no route drawn.': 'Nuk ka rrugë të vizatuar.',
  'Has fewer than two stops.': 'Ka më pak se dy stacione.',
  'Stops far from the route ({n}): {names}': 'Stacione larg rrugës ({n}): {names}',
  'Stops out of order ({n}): {names}': 'Stacione jashtë radhës ({n}): {names}',
  'Not on any direction (not shown with a line in the app).':
    'Nuk është në asnjë drejtim (nuk shfaqet me linjë në aplikacion).',
  'Two stations {m} m apart: probably the same stop.':
    'Dy stacione {m} m larg njëri-tjetrit: ndoshta i njëjti stacion.',
  'Times at {a} of {b} stops.': 'Orar në {a} nga {b} stacione.',
  'No timetable.': 'Nuk ka orar.',
  'Checks across lines, directions, stations and timetables. Problems affect what passengers see; the rest is worth a look.':
    'Kontrolle për linjat, drejtimet, stacionet dhe oraret. Problemet ndikojnë në atë që shohin pasagjerët; të tjerat ia vlen të shikohen.',
  'All good': 'Në rregull',
  'Nothing found.': "Asgjë për t'u rregulluar.",
  Problem: 'Problem',
  'To check': "Për t'u kontrolluar",
  Fix: 'Rregullo',
  '{n} problem': '{n} problem',
  '{n} problems': '{n} probleme',
  '{n} to check': "{n} për t'u kontrolluar",
  Alerts: 'Njoftimet',
  'Bus {bus} is assigned to {own} but drives {other}.':
    'Autobusi {bus} është caktuar në {own}, por qarkullon në {other}.',
  'Bus {bus} ({own}) is off its route.': 'Autobusi {bus} ({own}) është jashtë rrugës.',
  'Bus {bus} ({own}) has not moved, away from the terminus.':
    'Autobusi {bus} ({own}) nuk lëviz, larg stacionit fundor.',
  'No position from bus {bus} ({own}).': 'Asnjë pozitë nga autobusi {bus} ({own}).',
  'Line {line} has no bus in service.': 'Linja {line} nuk ka asnjë autobus në shërbim.',
  'Bus on the wrong line': 'Autobus në linjë të gabuar',
  'Bus off its route': 'Autobus jashtë rrugës',
  'Bus standing still (away from the terminus)': 'Autobus i ndalur (larg stacionit fundor)',
  'No position from a bus': 'Asnjë pozitë nga një autobus',
  'Line without a bus in service': 'Linjë pa autobus në shërbim',
  'Test requested: it is sent within a minute.': 'Testi u kërkua: dërgohet brenda një minute.',
  '{h} h {m} min': '{h} orë {m} min',
  'Raised automatically from the bus positions every minute. Staff can be told by e-mail or Telegram.':
    'Krijohen automatikisht nga pozitat e autobusëve çdo minutë. Stafi mund të njoftohet me e-mail ose Telegram.',
  'Open now': 'Të hapura tani',
  'Resolved (7 days)': 'Të zgjidhura (7 ditë)',
  'No open alerts.': 'Asnjë njoftim i hapur.',
  'Nothing resolved in the last 7 days.': 'Asgjë e zgjidhur në 7 ditët e fundit.',
  'for {d}': 'prej {d}',
  '{d}, resolved {when}': '{d}, u zgjidh {when}',
  'Who is told, and when': 'Kush njoftohet dhe kur',
  'Alerts on': 'Njoftimet aktive',
  'Alert when … for at least': 'Njofto kur … për të paktën',
  'Service hours': 'Orari i shërbimit',
  '(no signal, standing and empty lines only then)':
    '(pa sinjal, i ndalur dhe linja pa autobus vetëm atëherë)',
  'E-mail to': 'E-mail te',
  'name@example.com (Enter to add)': 'emri@shembull.com (Enter për ta shtuar)',
  'E-mail is not set up on the server (SMTP_HOST).': 'E-maili nuk është konfiguruar në server (SMTP_HOST).',
  'Telegram chat': 'Biseda në Telegram',
  'Add the bot to the staff group, then put the group’s chat id here.':
    'Shtoni botin në grupin e stafit, pastaj vendosni këtu ID-në e bisedës së grupit.',
  'Telegram is not set up on the server (TELEGRAM_BOT_TOKEN).':
    'Telegrami nuk është konfiguruar në server (TELEGRAM_BOT_TOKEN).',
  'Also tell when resolved': 'Njofto edhe kur zgjidhet',
  'Sending…': 'Duke dërguar…',
  'Send a test': 'Dërgo një test',
  'Test sent by {channels} at {time}.': 'Testi u dërgua me {channels} më {time}.',
  'Test failed: {message}': 'Testi dështoi: {message}',
  '{n} e-mail address': '{n} adresë e-maili',
  '{n} e-mail addresses': '{n} adresa e-maili',
  'See alerts': 'Shiko njoftimet',
  '{n} open alert': '{n} njoftim i hapur',
  '{n} open alerts': '{n} njoftime të hapura',
  'Not a bus': 'Nuk është autobus',
  /** Vehicle type option (the column header 'Bus' stays 'Busi'). */
  'A bus': 'Autobus',
  'New devices': 'Pajisje të reja',
  'Other vehicles': 'Automjete të tjera',
  Show: 'Shfaq',
  Type: 'Lloji',
  'Not shown in the apps, statistics, checks or alerts. Its line is removed on saving.':
    'Nuk shfaqet në aplikacione, statistika, kontrolle ose alarme. Linja i hiqet kur ruhet.',
  'New: not sorted yet': 'E re: ende pa u vendosur',
  Note: 'Shënim',
  'e.g. service car': 'p.sh. veturë shërbimi',
  'Arvento reports {n} new device: assign it a line, or mark it as not a bus.':
    'Arvento raporton {n} pajisje të re: caktojini një linjë ose shënojeni si jo autobus.',
  'Arvento reports {n} new devices: assign them a line, or mark them as not a bus.':
    'Arvento raporton {n} pajisje të reja: caktojuni një linjë ose shënojini si jo autobus.',
  'Shape replaced: save to keep it.': 'Forma u zëvendësua: ruajeni për ta mbajtur.',
  Copied: 'U kopjua',
  'Could not copy': 'Nuk u kopjua',
  Apply: 'Zbato',
  'Import file': 'Importo skedar',
  Copy: 'Kopjo',
  Download: 'Shkarko',
  'Paste a geometry, a Feature or a FeatureCollection, or import a GeoJSON, KML or KMZ file (the first matching shape is used). Coordinates are [longitude, latitude].':
    'Ngjitni një gjeometri, një Feature ose një FeatureCollection, ose importoni një skedar GeoJSON, KML ose KMZ (përdoret forma e parë që përputhet). Koordinatat janë [gjatësia gjeografike, gjerësia gjeografike].',
  'View, edit, import or export the shape (GeoJSON, KML, KMZ)':
    'Shikoni, ndryshoni, importoni ose eksportoni formën (GeoJSON, KML, KMZ)',
  'This file could not be read.': 'Ky skedar nuk mund të lexohej.',
  'This is not valid JSON.': 'Ky nuk është JSON i vlefshëm.',
  'No area (Polygon) found in it.': 'Nuk u gjet asnjë zonë (Polygon).',
  'No route (LineString) found in it.': 'Nuk u gjet asnjë itinerar (LineString).',
  'An area needs at least three distinct points.': 'Një zonë duhet të ketë të paktën tri pika të ndryshme.',
  'A route needs at least two distinct points.': 'Një itinerar duhet të ketë të paktën dy pika të ndryshme.',
  'Some coordinates are outside the map.': 'Disa koordinata janë jashtë hartës.',
  'The coordinates look swapped: GeoJSON uses [longitude, latitude].':
    'Koordinatat duken të ndërruara: GeoJSON përdor [gjatësia, gjerësia].',
} satisfies Record<string, string>;
